import { css } from "styled-components";

/**
 * Shared primary heading scale for marketing sections below HomeMain (/).
 * Apply to section-level h2; override
 * color/margin/text-align per section as needed.
 */
export const marketingSectionHeading = css`
  font-size: clamp(1.75rem, 4.2vw, 2.35rem);
  font-weight: 700;
  font-family: var(--font-primary);
  line-height: 1.2;
  letter-spacing: -0.02em;
`;
